// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultDropdown_wrapper__Yqfzh"};